<template>
  <div class="busy-spinner__overlay">
    <slot></slot>
  </div>
  <div class="busy-spinner__big">
    <div class="busy-spinner__container row justify-space-between">
      <div class="busy-spinner__dot mr-2"></div>
      <div class="busy-spinner__dot mb-2"></div>
      <div class="busy-spinner__dot mr-2"></div>
      <div class="busy-spinner__dot"></div>
    </div>
  </div>
</template>

<script lang="ts" setup></script>

<style scoped lang="scss">
  .busy-spinner {
    &__overlay {
      position: relative;
      background-color: rgba(255, 255, 255, 0.9);
      width: 100%;
      height: 100vh;
      padding: 10px 0;
      opacity: 0.4;
      overflow: visible;
      pointer-events: none;
    }

    &__big {
      position: absolute;
      display: flex;
      top: 40%;
      left: 50%;
    }

    &__container {
      width: 40px;
      height: 45px;
      margin: auto;
      animation: busy-spinner 3.5s infinite linear;
    }

    &__dot {
      width: 15px;
      height: 15px;
      background-color: var(--orange);
      border-radius: 50%;
    }
  }

  @keyframes busy-spinner {
    0% {
      transform: rotateZ(0deg) translate3d(0, 0, 0);
    }
    100% {
      transform: rotateZ(720deg) translate3d(0, 0, 0);
    }
  }
</style>
